import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Solutions from '../components/Solutions';
import Credibility from '../components/Credibility';
import Approach from '../components/Approach';
import WhyUs from '../components/WhyUs';
import SessionsTeaser from '../components/SessionsTeaser';
import ForCorporates from '../components/ForCorporates';
import ForColleges from '../components/ForColleges';
import ForIndividuals from '../components/ForIndividuals';
import Testimonials from '../components/Testimonials';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import './LandingPage.css';

export default function LandingPage() {
  useEffect(() => {
    const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Clean any hash present on initial load (e.g. someone opens /#contact directly).
    if (window.location.hash) {
      const el = document.getElementById(window.location.hash.slice(1));
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
    }

    // Delegate clicks on in-page hash anchors: scroll smoothly, keep the URL hash-free.
    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: prefersReduce ? 'auto' : 'smooth', block: 'start' });
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Credibility />
        <Solutions />
        <Approach />
        <WhyUs />
        <SessionsTeaser />
        <ForCorporates />
        <ForColleges />
        <ForIndividuals />
        <Testimonials />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
